<template>
  <v-touch class="primary h"
    @press="pressed($event)"
    @pan="pan($event)">
      <!-- <modal name="example"
        :focusTrap='true'
        :adaptive="false">
        Hello, Properties!
      </modal> -->
    <div class="item fullWidth fRow jStart aCenter"
      v-bind:style="{transform: `translateX(${this.dx / 1}px)`}"
      v-bind:class="{'transition-fast': !isPaning}" v-ripple='!itemSlided'>
      <div class="avatarHolder">
        <div class="avatar fCol jCenter aCenter" v-bind:style="{backgroundColor: randomColor}">
          <img :src="avatar" lazy-load
            v-if="avatar !== ''"
            alt="" class="avatar">
          <span>{{name.charAt(0)}}‌{{name.charAt(name.length - 1)}}</span>
        </div>
        <div class="badge"
          v-if="type === 0"
          v-bind:class="{online: state, offline: !state}"></div>
      </div>
      <div class="content growFull fCol jCenter aStart">
        <div class="firstRow fullWidth fRow jStart aCenter">
          <i class="material-icons-round chatIcon">{{computedTypeIcon}}</i>
          <div class="chatName growFull">{{name}}</div>
          <div class="states fRow jEnd aCenter">
            <i class="material-icons-round">{{computedIcon}}</i>
            <span class="date">{{lastDate}}</span>
          </div>
        </div>
        <div class="secondRow fullWidth fRow jStart aStart">
          <p class="chatPreview growFull">{{lastMessage}}</p>
          <span class="countBadge" v-if="unread > 0">{{unread}}</span>
        </div>
      </div>
    </div>
    </v-touch>
</template>

<script>
import '@/assets/chat.scss';

export default {
  props: ['type', 'name', 'date', 'lastMessage', 'lastState',
    'lastDate', 'unread', 'avatar', 'state'],
  data() {
    return {
      dx: 0,
      oldDx: 0,
      isPaning: false,
      itemSlided: false,
    };
  },
  methods: {
    pan(event) {
      this.isPaning = true;
      this.dx = this.oldDx + (event.deltaX * 0.5);
      if (this.dx < 0) {
        this.dx = 0;
      }
      // console.log(this.dx);
      // this.$refs.item.innerHTML = event.deltaX;
      if (event.isFinal) {
        // console.log('final');
        this.isPaning = false;
        if (this.dx < 70) {
          this.itemSlided = false;
          this.oldDx = 0;
          this.dx = 0;
        } else {
          this.itemSlided = true;
          this.oldDx = 142;
          this.dx = 142;
        }
      }
    },
    swipeHandler(s) {
      clearInterval(this.play);
      if (s === 'left') {
        // console.log('this.prev();');
      } else if (s === 'right') {
        // console.log('this.next();');
      }
    },
    pressed() {
      // this.$modal.show('example');
      if (this.itemSlided) {
        this.dx = 0;
        this.oldDx = 0;
        this.itemSlided = false;
      }
    },
  },
  computed: {
    computedIcon() {
      let icon = '';
      switch (this.lastState) {
        case 0: {
          // pending
          icon = 'loop';
          break;
        }
        case 1: {
          // sent
          icon = 'done';
          break;
        }
        case 2: {
          // recived
          icon = 'done_all';
          break;
        }
        case 3: {
          // error
          icon = 'report_problem';
          break;
        }
        default:
          break;
      }
      return icon;
    },
    randomColor() {
      return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
    },
    computedTypeIcon() {
      let icon = '';
      switch (this.type) {
        case 0: {
          // private
          icon = 'person';
          break;
        }
        case 1: {
          // group
          icon = 'groups';
          break;
        }
        default:
          break;
      }
      return icon;
    },
  },
};
</script>

<style lang="scss" scoped>
.h {
  height: 72px;
  overflow: hidden !important;
}
</style>
